import { render, staticRenderFns } from "./ActiveBacklogColumn.vue?vue&type=template&id=ba96ea90&"
import script from "./ActiveBacklogColumn.vue?vue&type=script&lang=js&"
export * from "./ActiveBacklogColumn.vue?vue&type=script&lang=js&"
import style0 from "./ActiveBacklogColumn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports